import { requests } from 'common/axios';

const baseUrl = 'api/MemberEnrollment';

export const RetryEnrollmentApi = {
    LoadFailedEnrollments: (params: any): Promise<any> => requests.get(`${baseUrl}/LoadFailedEnrollments`, params),
    RequeueEnrollmentProcess: (data: any): Promise<any> =>
        requests.post(`${baseUrl}/ResendEnrollmentToServiceBusQueue`, data),
};
